import React from 'react';
import styled from 'styled-components';
import onClickOutside from 'react-click-outside';
import Link from 'components/Link/Link';
import media from '../media/media';

import NavbarIcon from './NavbarIcon';

const SMALL_HORIZONTAL_SPACE = `${12/1920*100}vw`;
const MEDIUM_HORIZONTAL_SPACE = `${16/1920*100}vw`;
const LARGE_HORIZONTAL_SPACE = `${22/1920*100}vw`;

const ICON_LENGTH = '32px';

const Wrapper = styled.div`
  position: relative;
  height: ${({ side }) => side ? '50px' : '100%'};
  display: flex;
  align-items: center;
  justify-content: ${({ side }) => side ? 'flex-start' : 'space-around'};
  cursor: ${({ displayOnly }) => displayOnly ? 'auto' : 'pointer'};
  overflow: visible;
  transition: all 0.2s;
  background-color: ${({ expanded, active }) => (expanded || active) ? 'rgba(0,0,0,0.2)' : 'transparent'};
  padding-left: ${({ side }) => side ? '16px' : 0};

  &:hover {
    ${({ displayOnly }) => !displayOnly && 'background-color: rgba(0,0,0,0.2);'}
  }
`;

const Text = styled.span`
  font-family: RobotoMedium;
  color: white;
  padding-left: ${({ hasIcon }) => hasIcon ? 0 : LARGE_HORIZONTAL_SPACE};
  padding-right: ${LARGE_HORIZONTAL_SPACE};
  margin-left: ${({ side }) => side ? '32px' : 0};
`;

const Image = styled.img`
  width: ${({ width }) => width ? width : ICON_LENGTH};
  height: ${({ height }) => height ? height : ICON_LENGTH};
  margin-left: ${SMALL_HORIZONTAL_SPACE};
  margin-right: ${SMALL_HORIZONTAL_SPACE};
`;

const I = styled.i`
  color: white;
  font-weight: bold;
  margin-left: ${MEDIUM_HORIZONTAL_SPACE};
  margin-right: ${({ large }) => large ? '0px' : LARGE_HORIZONTAL_SPACE};
  ${({ large }) => large && 'font-size: 30px'};
`;

const Expander = styled.div`
  position: absolute;
  min-width: 150px;
  top: 72px;
  ${({dropDownSide}) => (dropDownSide === "left") && "left: 0;"}
  ${({dropDownSide}) => (dropDownSide === "right") && "right: 0;"}
  z-index: 100;
  background-color: #303030;
  overflow: hidden;
  transition: all 0.2s;

  transform: translateX(${({ expanded }) => expanded ? 0 : '5px'});
  opacity: ${({ expanded }) => expanded ? 1 : 0};
  pointer-events: ${({ expanded }) => expanded ? 'auto' : 'none'};
  display: ${({ expanded }) => expanded ? 'block' : 'none'};

  ${media.portrait`
    top: 48px;
  `}
`;

const ExpandedItem = styled.div`
  height: 72px;
  width: 100%;
  align-items: center;
  padding-left: 8px;
  padding-right: 16px;
  display: flex;
  color: white;
  font-family: Roboto;
`;

const UCTainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
UCTainer.displayName = 'UCTainer';
const UnderConstruction = styled.div`
  background-color: black;
  border: 3px dotted yellow;
  transform: rotate(17deg);
  color: yellow;
  padding: 2px;
  font-size: 10px;
  opacity: 0.8;
`;

class NavBarItem extends React.Component {
  constructor() {
    super();

    this.state = {
      expanded: false
    };
  }
  handleClickOutside = () => {
    if (!this.state.expanded) {
      return;
    }

    this.setState({
      expanded: !this.state.expanded
    });
  };
  handleClick = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };
  renderItem = ({ title, icon, to, onClick, className, iconInDropdown, preventFlipX }, i) => {
    let item = (
      <ExpandedItem className={className} key={i} onClick={onClick}>
        {iconInDropdown ?
          <NavbarIcon title={title} icon={icon} flipX={!preventFlipX} /> :
          title
        }
      </ExpandedItem>
    );

    if (to) {
      item = <Link key={i} to={to}>{item}</Link>;
    }

    return item;
  };
  render() {
    const { items, icon, title, tooltip, active, side, to, uc, className, customDropIcon, id, tourExpanded, displayOnly, fontIcon, image, dropDownSide } = this.props;
    const expanded = tourExpanded == null ? this.state.expanded : tourExpanded;

    const children = (
      <Wrapper 
        id={id} 
        className={className} 
        side={side}
        active={active} 
        expanded={expanded} 
        onClick={items ? this.handleClick : this.props.onClick}
        displayOnly={displayOnly}
        dropdown={items}
      >
        {icon && <Image src={icon} title={tooltip} />}
        {fontIcon && <I className={fontIcon} large title={tooltip} />}
        {title && <Text side={side} hasIcon={!!icon}>{title}</Text>}
        {image && <Image src={image} width="auto" height="52px" />}
        {items && (!!customDropIcon ?
          <Image src={customDropIcon} /> :
          <I className="fas fa-angle-down" />
        )}
        {items && (
          <Expander expanded={expanded} dropDownSide={dropDownSide}>
            {items.map(this.renderItem)}
          </Expander>
        )}
        {uc && (
          <UCTainer>
            <UnderConstruction>
              Under Construction
            </UnderConstruction>
          </UCTainer>
        )}
      </Wrapper>
    );

    if (to) {
      return <Link to={to}>{children}</Link>
    } else {
      return children;
    }
  }
}

export default onClickOutside(NavBarItem);


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarItem.js